import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import MyCarousel from '../components/Carousel/Carousel'
import AboutSection from '../components/About/AboutSection'
import ServicesSection from '../components/Services/ServicesSection'
import InternshipCTA from '../components/Services/InternshipCTA'
import WhyChooseUs from '../components/Services/WhyChooseUs'

const HomePage = () => {
  return (
    <div>
        <Navbar/>
        <MyCarousel/>
        <ServicesSection/>
        <InternshipCTA/>
        <WhyChooseUs/>
        <Footer/>
    </div>
  )
}

export default HomePage